import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const KlappeRLTStellung = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  //========================================================================
  // Position als Wert aus globalVars
  let position = Math.abs(parseInt(value.value));

  //========================================================================
  // Simulation
  let simulation = false;
  let simValue = 0;

  try {
    simulation = props.style.properties.simulation;
    simValue = props.style.properties.simValue;
  } catch (error) {
    simulation = false;
  }

  if (simulation) {
    position = Math.abs(parseInt(simValue));
  }

  //========================================================================
  // Bilder laden
  const path000 = require("../../images/controls/KlappeRLTStellung/Klappe_000.png");
  const path025 = require("../../images/controls/KlappeRLTStellung/Klappe_025.png");
  const path050 = require("../../images/controls/KlappeRLTStellung/Klappe_050.png");
  const path075 = require("../../images/controls/KlappeRLTStellung/Klappe_075.png");
  const path100 = require("../../images/controls/KlappeRLTStellung/Klappe_100.png");

  let imagePath = path000;
  if (isFinite(position)) {
    if (position > 5 && position <= 25) {
      imagePath = path025;
    } else if (position > 25 && position <= 50) {
      imagePath = path050;
    } else if (position > 50 && position <= 75) {
      imagePath = path075;
    } else if (position > 75) {
      imagePath = path100;
    }
  }

  return (
    <img
      style={{
        ...props.style,
        visibility: props.props.visibility,
      }}
      title={
        props.element.tooltip
          ? language.displayText(props.element.tooltip) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "")
          : language.displayText(value.name) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "") +
            (globalVars.cyclicUpdate || globalVars.editor
              ? "\n" + ("Variable: " + props.props.variable)
              : "")
      }
      src={imagePath}
    />
  );
});

export default KlappeRLTStellung;
